/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
export type Marketing_Support_Enum =
  | 'FURNITURE'
  | 'OTHER'
  /** English acronym for 'PLV' */
  | 'POS';

export type Return_Policy_Enum =
  | 'FULL'
  | 'PARTIAL';

export type CompanyServicesFragmentFragment = { provide_marketing: boolean | null, marketing_details: string | null, provide_animation: boolean | null, animation_details: string | null, provide_electrical_appliance: boolean | null, electrical_appliance_details: string | null, provide_return_policy: boolean | null, return_policy: Types.Return_Policy_Enum | null, return_policy_details: string | null, provide_merchandising: boolean | null, merchandising_details: string | null, marketing_supports: Array<{ support: Types.Marketing_Support_Enum }> };

export const CompanyServicesFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment companyServicesFragment on company {
  provide_marketing
  marketing_details
  marketing_supports {
    support
  }
  provide_animation
  animation_details
  provide_electrical_appliance
  electrical_appliance_details
  provide_return_policy
  return_policy
  return_policy_details
  provide_merchandising
  merchandising_details
}
    `;